<main
    class="bg-cover bg-center bg-no-repeat h-screen w-full flex items-center justify-center lg:grid grid-cols-2"
    style="background-image: url('./assets2023/img/bg_login.jpg');"
>

    <div class="bg-white rounded-lg lg:rounded-none m-8 lg:m-0 py-12 px-6 lg:pt-20 shadow max-h-90vh lg:max-h-screen lg:h-full overflow-y-auto lg:flex flex-col items-center justify-center">

        <div class="max-w-300px lg:h-full flex flex-col">

            <a href="javascript:;" (click)="backToLogin($event)" class="text-sm font-bold underline mb-12">
                {{ 'remember_goto' | translate }} <strong>{{ 'remember_login' | translate }}</strong>
            </a>

            <!-- Main Image -->
            <div class="flex justify-center mb-6 lg:mb-12">
                <img src="./assets2023/img/logo.svg" alt="Logo" class="w-75px lg:w-145px h-55px lg:h-100px" />
            </div>
            <!-- END Main Image -->

            <!-- Title -->
            <h1 class="text-2xl font-bold text-center">
                {{ 'login_remember_password' | translate }}
            </h1>
            <!-- END Title -->

            <!-- Description -->
            <p class="text-sm mt-2">
                {{ 'remember_text' | translate }}
            </p>
            <!-- END Description -->

            <form [formGroup]="rememberForm" (ngSubmit)="onSubmit()">
                <div class="flex flex-col space-y-5 mt-6 text-sm">

                    <!-- User -->
                    <div>
                        <label for="username">
                            {{ 'remember_user' | translate | titleCase }}
                        </label>

                        <input
                            formControlName="user"
                            type="text"
                            id="username"
                            name="username"
                            placeholder="{{ 'remember_user' | translate | titleCase }}"
                            class="mt-1 w-full rounded-lg border border-light focus:outline-light-blue px-2 h-45px"
                        >
                        <p
                            *ngIf="isFieldUnvalid('user')"
                            class="text-featured text-xs"
                            >
                            {{ 'remember_user_required' | translate }}
                        </p>

                    </div>

                    <!-- Service OK Message -->
                    <app-alert-text *ngIf="isRememberMessageOK" type="success">{{ 'remember_login_ok' | translate }}</app-alert-text>

                    <!-- Service KO Message -->
                    <app-alert-text *ngIf="rememberMessageKO?.length" type="error">{{ 'remember_login_error' | translate }}</app-alert-text>

                    <!-- Submit button -->
                    <div class="grid">
                        <button
                            type="submit"
                            class="text-white bg-secondary border-secondary hover:bg-white hover:text-primary hover:border-primary font-semibold text-md rounded border transition duration-300 px-8 h-45px"
                            [disabled]="!rememberForm.valid"
                        >
                            <ng-container *ngIf="!loading">
                                {{ 'remember_send' | translate | titleCase }}
                            </ng-container>
                        </button>
                    </div>
                </div>
            </form>

            <app-languages-links class="hidden lg:flex flex-1 justify-center items-end mt-9 lg:pb-12"></app-languages-links>

        </div>

    </div>

    <div class="hidden lg:block bg-cover bg-center bg-no-repeat h-full w-full pl-32" style="background-image: url('./assets2023/img/bg_triangles.png');">
        <div class="flex justify-end items-end h-full">
            <div class="text-white text-xs text-right max-w-400px pr-9 xl:pr-14 py-9">
                {{'si no recuerdas tus claves' | translate}}.
            </div>
        </div>
    </div>
</main>
